import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, Store } from '@ngrx/store';

import * as RelatedProductsEffects from './infrastructure/state/related-products.effects';
import { relatedProductsReducer } from './infrastructure/state/related-products.reducer';

import { ProductsFeatureModule } from '@features/products/product/product-feature.module';
import { WishlistFeatureModule } from '@features/wishlist/wishlist-feature.module';
import { LoadAnalyticsModule } from '@shared/analytics/store/analytics.actions';
import { StaticResourceService } from '@shared/services/static-resources/static-resource.service';

@NgModule({
    imports: [
        ProductsFeatureModule, // Required by the related-products.effects.ts
        WishlistFeatureModule, // Required by the related-products.effects.ts
    ],
    providers: [
        provideState({ name: 'related-products', reducer: relatedProductsReducer }),
        provideEffects(RelatedProductsEffects),
        StaticResourceService, // Required by the related-products.effects.ts
    ],
})
export class RelatedProductsModule {
    constructor(public store: Store) {
        this.store.dispatch(LoadAnalyticsModule({ moduleName: 'AnalyticsRelatedProductsModule' }));
    }
}
